import { useEffect, useState } from 'react';
import './products.css'
export default function Products() {
  const [products, setProducts] = useState([]);
  const [newProduct, setNewProduct] = useState({ code: '', brand: '', name: '', description: '' });
  const [editingProduct, setEditingProduct] = useState(null);
  const [productdata , setProductdata] = useState('')

  useEffect(() => {
    // بارگذاری لیست محصولات از سرور
    fetch('http://185.164.73.170:5000/products')
      .then(response => response.json())
      .then(data => setProducts(data))
      .catch(error => console.error('Error fetching products:', error));
  }, []);

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setNewProduct(prevState => ({ ...prevState, [name]: value }));
  };

  const addProduct = () => {
    fetch('http://185.164.73.170:5000/products', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify({ ...newProduct, id: Date.now().toString() }),
    })
      .then(response => response.text())
      .then(() => {
        setProducts(prevProducts => [...prevProducts, { ...newProduct, id: Date.now().toString() }]);
        setNewProduct({ code: '', name: '', description: '', brand: '' });
      })
      .catch(error => console.error('Error adding product:', error));
  };

  const deleteProduct = (id) => {
    fetch(`http://185.164.73.170:5000/products-delete/${id}`, {
      method: 'DELETE',
    })
      .then(response => response.text())
      .then(() => {
        setProducts(prevProducts => prevProducts.filter(product => product.id !== id));
      })
      .catch(error => console.error('Error deleting product:', error));
  };

  const startEditing = (product) => {
    setEditingProduct(product);
  };

  const cancelEditing = () => {
    setEditingProduct(null);
  };

  const saveProduct = () => {
    fetch(`http://185.164.73.170:5000/products/${editingProduct.id}`, {
      method: 'PUT',
      headers: {
        'Content-Type': 'application/json',
      },
      body: JSON.stringify(editingProduct),
    })
      .then(response => response.text())
      .then(() => {
        setProducts(prevProducts =>
          prevProducts.map(product => (product.id === editingProduct.id ? editingProduct : product))
        );
        setEditingProduct(null);
      })
      .catch(error => console.error('Error saving product:', error));
  };
  function searchingproductdata(e) {
    setProductdata(e.target.value)
  }
  const filtersearch = products.filter(item => {
    const namesearch = item.code.toLowerCase(); 
    const valuesearch = productdata;
    return valuesearch && namesearch.includes(valuesearch)})
  return (
    <div>
      <div className="add-product-form">
        <input
          type="number"
          name="code"
          placeholder="کد محصول"
          value={newProduct.code}
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="brand"
          placeholder="اسم برند"
          value={newProduct.brand}
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="name"
          placeholder="اسم محصول"
          value={newProduct.name}
          onChange={handleInputChange}
        />
        <input
          type="text"
          name="description"
          placeholder="مقدار محصول"
          value={newProduct.description}
          onChange={handleInputChange}
        />
        <button onClick={addProduct}>اضافه کردن محصول جدید</button>
      </div>
      <ul className='searchresult'>
        <input className='searchproduct' type='search' placeholder='جست و جوی محصول بر اساس کد' onChange={searchingproductdata}></input>
        {filtersearch.length > 0 ? (
        filtersearch.map(product => (
          <li key={product.id} className="product-card">
            {editingProduct && editingProduct.id === product.id ? (
              <div>
                <input
                  type="number"
                  name="code"
                  value={editingProduct.code}
                  onChange={(e) => setEditingProduct({ ...editingProduct, code: e.target.value })}
                />
                <input
                  type="text"
                  name="name"
                  value={editingProduct.name}
                  onChange={(e) => setEditingProduct({ ...editingProduct, name: e.target.value })}
                />
                <input
                  type="text"
                  name="brand"
                  value={editingProduct.brand}
                  onChange={(e) => setEditingProduct({ ...editingProduct, brand: e.target.value })}
                />
                <input
                  type="text"
                  name="description"
                  value={editingProduct.description}
                  onChange={(e) => setEditingProduct({ ...editingProduct, description: e.target.value })}
                />
                <button onClick={saveProduct} className="edit">Save</button>
                <button onClick={cancelEditing} className="delete">Cancel</button>
              </div>
            ) : (
              <div className="product-details">
                <h4>{product.name}</h4>
                <p>کد محصول : {product.code}</p>
                <p>برند محصول : {product.brand}</p>
                <p>مقدار محصول : {product.description}</p>
                <div className="product-actions">
                  <button onClick={() => startEditing(product)} className="edit">Edit</button>
                  <button onClick={() => deleteProduct(product.id)} className="delete">Delete</button>
                </div>
              </div>
            )}
          </li>
        ))) : (
          <p className='errorsearch'>محصولی پیدا نشد</p>
      )}
      </ul>
    </div>
  );
}